module.exports = __webpack_public_path__ + "media/images/payment-icons-e1f8e2a3f0f951dbf9c2befdf5f2fab9.png";